/**
 * DAYS THEME: Product Info Accordion
 * Acordeon para mostrar/ocultar a descrição do produto
 * Acionado pelo botão "INFORMAÇÃO" na view de seleção
 *
 * Efeito similar ao toggle +/× (transição de 300ms)
 */

class DaysProductInfoAccordion {
  constructor() {
    this.button = document.querySelector('.product-info-toggle');
    this.content = document.querySelector('.product-info-content');
    this.isExpanded = false;

    if (!this.button || !this.content) {
      console.warn('[Days Product Info Accordion] Elementos não encontrados');
      return;
    }

    this.init();
    this.setupViewObserver();
  }

  init() {
    // Event listener no botão
    this.button.addEventListener('click', () => this.toggle());
  }

  setupViewObserver() {
    // Monitorar quando a view de seleção fecha para resetar o acordeon
    const selectionView = document.querySelector('.product-view--selection');

    if (!selectionView) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          // Se view perdeu classe 'active', resetar acordeon
          if (!selectionView.classList.contains('active')) {
            this.reset();
          }
        }
      });
    });

    observer.observe(selectionView, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      // Expandir descrição
      this.expand();
    } else {
      // Fechar descrição
      this.collapse();
    }
  }

  expand() {
    console.log('[Days Accordion] Expanding...');

    // PASSO 1: Ocultar o botão primeiro
    this.button.classList.add('expanded');
    this.button.setAttribute('aria-expanded', 'true');

    // PASSO 2: Aguardar o botão desaparecer completamente (200ms) antes de expandir conteúdo
    setTimeout(() => {
      // Expandir o container (CSS cuida da transição)
      this.content.classList.add('expanded');
      console.log('[Days Accordion] Content expanded after button hidden');
    }, 200); // Delay de 200ms para evitar glitch de scroll

    console.log('[Days Accordion] Button hidden, content will expand shortly');
  }

  collapse() {
    console.log('[Days Accordion] Collapsing...');

    // Remover classe 'expanded' do container (CSS cuida da transição)
    this.content.classList.remove('expanded');

    // Atualizar aria
    this.button.setAttribute('aria-expanded', 'false');

    // Mostrar o texto "INFORMAÇÃO" novamente
    this.button.classList.remove('expanded');
  }

  reset() {
    console.log('[Days Accordion] Resetting...');

    // PASSO 1: Colapsar o conteúdo PRIMEIRO
    this.isExpanded = false;
    this.content.classList.remove('expanded');

    // PASSO 2: Aguardar conteúdo colapsar (300ms) antes de mostrar botão novamente
    setTimeout(() => {
      // Mostrar o botão "INFORMAÇÃO" novamente
      this.button.setAttribute('aria-expanded', 'false');
      this.button.classList.remove('expanded');
      console.log('[Days Accordion] Button restored after content collapsed');
    }, 300); // Delay de 300ms (duração da transição CSS)

    console.log('[Days Accordion] Content collapsing, button will restore shortly');
  }
}

// Inicializar quando o DOM carregar
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new DaysProductInfoAccordion();
  });
} else {
  new DaysProductInfoAccordion();
}
